"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var NavMenu_1 = require("./NavMenu");
var SideBarMenu_1 = require("./SideBarMenu");
exports.default = (function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(NavMenu_1.default, null),
    React.createElement(reactstrap_1.Container, { fluid: true },
        React.createElement(reactstrap_1.Row, null,
            React.createElement(reactstrap_1.Col, { md: "2", style: { paddingLeft: "0", zIndex: 1 } },
                React.createElement(SideBarMenu_1.default, null)),
            React.createElement(reactstrap_1.Col, { md: "10", style: { marginLeft: 0 } },
                React.createElement("main", { role: "main", style: { minHeight: "92.5vh" } }, props.children)))))); });
//# sourceMappingURL=SubLayout.js.map